export default __webpack_public_path__ + "static/image-3-19662a88c1e4773e7a94bdea779c4230.jpg";